<template>
  <div class="Main" style="padding-bottom:0;">
    <div class="topMain">
      <div slot="header" class="clearfix">
        <span>操作日志</span>
        <el-button type="danger" icon="el-icon-delete" @click="handleClean" v-has="'operLog:operateClear'"
          style="float: right;margin-right:20px">清空</el-button>
        <el-button type="danger" icon="el-icon-delete" @click="handleDelete" v-has="'operLog:operateDel'"
          style="float: right;margin-right:20px">删除</el-button>
      </div>
    </div>
    <el-form :model="queryParams" ref="queryForm" :inline="true" class="demo-form-inline" style="margin-top: 15px;">
      <el-form-item label="操作名称" prop="title">
        <el-input v-model="queryParams.title" placeholder="请输入操作名称" clearable style="width: 240px;"
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item label="操作人员" prop="operName">
        <el-input v-model="queryParams.operName" placeholder="请输入操作人员" clearable style="width: 240px;"
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item label="类型" prop="businessType">
        <el-select v-model="queryParams.businessType" placeholder="操作类型" clearable style="width: 240px">
          <el-option v-for="dict in dictData" :key="dict.value" :label="dict.label" :value="dict.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="操作状态" prop="status">
        <el-select placeholder="请选择" v-model="queryParams.status">
          <el-option label="成功" value="0"></el-option>
          <el-option label="失败" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作时间">
        <el-date-picker v-model="dateRange" style="width: 240px" value-format="yyyy-MM-dd" type="daterange"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item class=" checkPlandiv_but">
        <el-button type="primary" @click="handleQuery">搜索</el-button>
        <el-button @click="resetQuery"><i class="el-icon-refresh"></i>重置</el-button>
      </el-form-item>
    </el-form>

    <el-card>
      <el-table ref="tables" v-loading="loading" :data="list" @selection-change="handleSelectionChange"
        :default-sort="defaultSort" @sort-change="handleSortChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="序号" align="center" type="index" />
        <el-table-column label="操作名称" align="center" prop="title" />
        <el-table-column label="操作类型" align="center" prop="businessType">
          <template slot-scope="scope">
            <el-tag type="info"
              v-if="[0,1, 2].includes(scope.row.businessType)">{{dictData[scope.row.businessType].label}}</el-tag>
            <el-tag type="danger"
              v-if="[3,7, 9].includes(scope.row.businessType)">{{dictData[scope.row.businessType].label}}</el-tag>
            <el-tag type="warning"
              v-if="[5,6, 8].includes(scope.row.businessType)">{{dictData[scope.row.businessType].label}}</el-tag>
            <el-tag v-if="[4].includes(scope.row.businessType)">{{dictData[scope.row.businessType].label}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="请求方式" align="center" prop="requestMethod" />
        <el-table-column label="操作人员账号" align="center" prop="operName" width="100" :show-overflow-tooltip="true"
          sortable="custom" />
        <el-table-column label="操作地址" align="center" prop="operIp" width="130" :show-overflow-tooltip="true" />
        <el-table-column label="操作地点" align="center" prop="operLocation" :show-overflow-tooltip="true" />
        <el-table-column label="操作状态" align="center" prop="status">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 0">成功</el-tag>
            <el-tag type="danger" v-if="scope.row.status == 1">失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作日期" align="center" prop="operTime" sortable="custom"
          :sort-orders="['descending', 'ascending']" :formatter="dateFormat" width="180">
          <!-- <template slot-scope="scope">
            <span>{{ scope.row.operTime }}</span>
          </template> -->
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button size="mini" type="text" icon="el-icon-view" @click="handleView(scope.row,scope.index)"
              v-has="'operLog:operateDetail'">详细</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="queryParams.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>

    <!-- 操作日志详细 -->
    <el-dialog title="操作日志详细" :visible.sync="open" width="700px" append-to-body>
      <el-form ref="form" :model="form" label-width="100px" size="mini">
        <el-row>
          <el-col :span="12">
            <el-form-item label="操作名称：">{{ form.title }} / {{ typeFormat(form) }}</el-form-item>
            <el-form-item label="登录信息：">{{ form.operName }} / {{ form.operIp }} / {{ form.operLocation }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="请求地址：">{{ form.operUrl }}</el-form-item>
            <el-form-item label="请求方式：">{{ form.requestMethod }}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="操作方法：">{{ form.method }}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="请求参数：">{{ form.operParam }}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="返回参数：">{{ form.jsonResult }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作状态：">
              <div v-if="form.status === 0">正常</div>
              <div v-else-if="form.status === 1">失败</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作时间：" >{{ dateFormat2(form.operTime) }}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="异常信息：" v-if="form.status === 1">{{ form.errorMsg }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="open = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import { list, delOperlog, cleanOperlog } from "@/api/monitor/operlog";
  import API from "../../api/api";
  import dayjs from "dayjs"
  export default {
    name: "Operlog",
    dicts: ['sys_oper_type', 'sys_common_status'],
    data() {
      return {
        // 遮罩层
        loading: true,
        // 选中数组
        ids: [],
        // 非多个禁用
        multiple: true,
        // 显示搜索条件
        showSearch: true,
        // 总条数
        total: 0,
        // 表格数据
        list: [],
        // 是否显示弹出层
        open: false,
        // 日期范围
        dateRange: [],
        // 默认排序
        defaultSort: { prop: 'operTime', order: 'descending' },
        // 表单参数
        form: {},
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          title: undefined,
          operName: undefined,
          businessType: undefined,
          status: undefined
        },
        dictData: [
          { label: '其他', value: 0 },
          { label: '新增', value: 1 },
          { label: '修改', value: 2 },
          { label: '删除', value: 3 },
          { label: '授权', value: 4 },
          { label: '导出', value: 5 },
          { label: '导入', value: 6 },
          { label: '强退', value: 7 },
          { label: '生成代码', value: 8 },
          { label: '清空数据', value: 9, },
        ]
      };
    },
    created() {
      this.getList();
    },
    methods: {
      /** 查询操作日志 */
      getList() {
        this.loading = true;
        if (this.dateRange.length > 0) {
          this.queryParams.beginTime = this.dateRange[0]
          this.queryParams.endTime = this.dateRange[1]
        } else {
          this.queryParams.beginTime = null
          this.queryParams.endTime = null
        }
        API.operateLogList(this.queryParams).then(response => {
          this.list = response.data.resultPage;
          this.total = response.data.total;
          this.loading = false;
        }
        );
      },
      dateFormat(row, column, cellValue, index) {
        if (row[column.property]) {
          return dayjs(new Date(row[column.property])).format("YYYY-MM-DD HH:mm:ss")
        } else {
          return '--'
        }
      },
      dateFormat2(date) {
        if (date) {
          return dayjs(new Date(date)).format("YYYY-MM-DD HH:mm:ss")
        } else {
          return '--'
        }
      },
      // 操作日志类型字典翻译
      typeFormat(row, column) {
        // return this.selectDictLabel(this.dict.type.sys_oper_type, row.businessType);
      },
      /** 搜索按钮操作 */
      handleQuery() {
        this.queryParams.pageNum = 1;
        this.getList();
      },
      /** 重置按钮操作 */
      resetQuery() {
        this.dateRange = [];
        this.$refs["queryForm"].resetFields();
        this.$refs.tables.sort(this.defaultSort.prop, this.defaultSort.order)
        this.handleQuery();
      },
      /** 多选框选中数据 */
      handleSelectionChange(selection) {
        this.ids = selection.map(item => item.operId)
        this.multiple = !selection.length
      },
      /** 排序触发事件 */
      handleSortChange(column, prop, order) {
        this.queryParams.orderByColumn = column.prop;
        this.queryParams.isAsc = column.order;
        this.getList();
      },
      /** 详细按钮操作 */
      handleView(row) {
        this.open = true;
        console.log(row)
        this.form = row;
      },
      /** 删除按钮操作 */
      handleDelete(row) {
        const operIds = row.operId || this.ids;
        this.$confirm('是否确认删除当前选中的数据项？').then(function () {
          return API.delOperlog(operIds);
        }).then(() => {
          this.getList();
          this.$message.success('删除成功')
        }).catch(() => { });
      },
      /** 清空按钮操作 */
      handleClean() {
        this.$confirm('是否确认清空所有操作日志数据项？').then(function () {
          return API.cleanOperlog();
        }).then(() => {
          this.getList();
          this.$message.success('清空成功')
        }).catch(() => { });
      },
      /** 导出按钮操作 */
      handleExport() {
        this.download('monitor/operlog/export', {
          ...this.queryParams
        }, `operlog_${new Date().getTime()}.xlsx`)
      },
      //分页
      handleSizeChange(val) {
        this.queryParams.pageSize = val;
        this.queryParams.pageNum = 1
        this.getList()
      },
      handleCurrentChange(val) {
        this.queryParams.pageNum = val;
        this.getList()
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/views/platform/operLog.vue